<!--
 * @Description: 客户代码下拉选择框
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-08 16:22:10
 * @LastEditors: cxh
-->
<template>
  <CosSelect
    v-model:value="data"
    style="width: 100%"
    @popupScroll="popupScroll"
    :showSearch="true"
    :filter-option="false"
    @search="fetchCode"
    @change="change"
  >
    <a-select-option
      v-for="item in optionPage"
      :disabled="disabledData.includes(item.arkCode) && data !== item.arkCode ? true : false"
      :key="item.id"
      :value="item.id"
      >{{ item.arkCode }}</a-select-option
    >
  </CosSelect>
</template>
<script lang="ts" setup>
import { ref, toRaw, onMounted, watch } from 'vue'
import type { SelectProps } from 'ant-design-vue'
import { customerCodeDelectSelect } from '@/api/overseasSales/customerCenter'
import { debounce, cloneDeep } from 'lodash-es'
const props = defineProps({
  value: {
    type: Object
  },
  firstData: {
    type: Array
  },
  label: {
    type: [String, Array]
  },
  cosId: {
    type: String
  },
  requiredCosId: {
    type: Boolean,
    default: true
  },
  stage: {
    type: Array,
    default: () => {
      return [2, 3, 4] // 2.潜在 3签约 4 成交
    }
  },
  disabledData: {
    type: Array,
    default: () => {
      return []
    }
  }
})
const pageNumber = ref(2)
const data = ref()
const searchTxt = ref()
const emit = defineEmits(['update:value', 'change', 'update:label'])
const optionPage = ref<any[]>([])
// 赋值
watch(
  () => props.label,
  (v, prev) => {
    if (v && v !== data.value) {
      data.value = v
    } else if (!v) {
      data.value = undefined
    }
  },
  { immediate: true }
)
const change: SelectProps['onChange'] = (value) => {
  const find = optionPage.value.find((item) => item.id === value)
  emit('update:label', find?.arkCode)
  emit('update:value', value)
  emit('change', value)
  // 清除搜索
  if (!value && searchTxt.value) {
    fetchCode('')
  }
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
// const fetchValue = (arkCode: any) => {
//   customerCodeDelectSelect({
//     pageNumber: 1,
//     pageSize: 100,
//     arkCode,
//     cosId: props.cosId
//   }).then((res) => {
//     optionPage.value = [...optionPage.value, ...res.data.items]
//   })
// }
const fetchCode = debounce((txt: string) => {
  searchTxt.value = txt?.trim()
  pageNumber.value = 1
  optionPage.value = []
  fetch()
}, 500)
// 获取公司下拉列表
const fetch = () => {
  customerCodeDelectSelect({
    pageNumber: pageNumber.value,
    pageSize: 100,
    arkCode: searchTxt.value,
    stage: props.stage,
    cosId: props.cosId
  }).then((res) => {
    optionPage.value = [...optionPage.value, ...res.data.items]
  })
}
onMounted(() => {
  if (props.firstData && props.firstData.length) {
    optionPage.value = cloneDeep(toRaw(props.firstData))
    pageNumber.value = 1
  }
})
</script>
<script lang="ts">
export default { name: 'RelationCodeSelect' }
</script>
